import { useCallback } from 'react';

import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import { ComponentEmptyButton } from '../shared/component-parts';
import { EditProps } from './document.constants';
import { ComponentDimensions } from '../shared/component-height/component-dimensions';
import { useBatchComponentUpdateContext } from '../shared/batch-component-update.context';
import DocumentEditPreview from './document-edit-preview';
import { DOCUMENT } from 'global/constants';
import {
  getClosestImageUrl,
  ImageDisplayQuality,
} from 'approot/shared/images/imgix-responsive';
import { useImageDimensionEffect } from 'approot/shared/images/images.hooks';
import { ComponentAbsoluteWrapper } from '../shared/component-height/component-dimensions.style';
import { getSmallestImage } from '../shared/logic/get-smallest-image';

const DocumentEdit = (props: EditProps) => {
  const { sectionId, id, properties } = props;

  const { openDrawer, activeComponent } = useActivityBuilderContext();
  const { updateComponentProperties } = useBatchComponentUpdateContext();

  const { imageDimensions, setContainerElement } = useImageDimensionEffect({
    imageUrl: getSmallestImage(
      props.stimulusResourceProperties?.xlCoverImageUrls || []
    ),
  });

  const handleHeightUpdate = useCallback(
    (width: number, height: number) => {
      updateComponentProperties({
        input: {
          sectionId,
          componentId: id,
          componentData: {
            properties: {
              dimensionData: {
                width,
                height: Math.floor(height),
              },
            },
          },
        },
        properties: {
          ...properties,
          dimensionData: {
            __typename: 'ComponentDimension',
            width,
            height: Math.floor(height),
          },
        },
        typename: 'ActivitiesDocumentComponent',
      });
    },
    [id, sectionId, properties, updateComponentProperties]
  );

  return props.stimulusResourceProperties ? (
    <ComponentDimensions
      id={id}
      showHandle={activeComponent?.id === props.id}
      defaultValue={properties.dimensionData}
      onResizeEnd={handleHeightUpdate}
    >
      {props.stimulusResourceProperties?.documentKey ? (
        <ComponentAbsoluteWrapper ref={setContainerElement}>
          <DocumentEditPreview
            documentKey={props.stimulusResourceProperties.documentKey}
            name={props.stimulusResourceProperties.resourceName}
            description={props.stimulusResourceProperties.description}
            coverImage={
              props.stimulusResourceProperties.xlCoverImageUrls?.length
                ? getClosestImageUrl({
                    imageUrls:
                      props.stimulusResourceProperties.xlCoverImageUrls,
                    containerSize: imageDimensions?.width
                      ? Math.max(imageDimensions.width, imageDimensions.height)
                      : window.innerWidth,
                    quality: ImageDisplayQuality.High,
                  })
                : props.stimulusResourceProperties.coverImage?.original ||
                  undefined
            }
            badgeName="Document"
            type={DOCUMENT}
            link={props.stimulusResourceProperties.link}
            showDetails={false} // todo: will be redesigned
          />
        </ComponentAbsoluteWrapper>
      ) : null}
    </ComponentDimensions>
  ) : (
    <>
      <ComponentEmptyButton
        iconId="document"
        onClick={() => openDrawer({ componentId: props.id })}
        buttonText="Add Document"
      />
    </>
  );
};

export default DocumentEdit;
